<template>
    <div class="tab-content">
        <medication-form
            v-show="physician.NetworkTab"
            :availHipaaForms="availHipaaForms"
            :recordTypeSources="recordTypeSources"
            @refresh-record-request="emitEvent({ name: 'refresh-record-request' })"
        ></medication-form>

        <email-form
            v-show="physician.EmailTabs"
            :availHipaaForms="availHipaaForms"
            :recordTypeSources="recordTypeSources"
            @refresh-record-request="emitEvent({ name: 'refresh-record-request' })"
        ></email-form>

        <hippa-form
            v-show="physician.HipaaTab"
            :availHipaaForms="availHipaaForms"
            @refresh-hipaa="getPatientHipaaForms"
        ></hippa-form>
    </div>
</template>
<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import PhysicianMixin from 'mixins/PhysicianMixin'
    import MedicationForm from 'components/forms/medication-network/MedicationForm'
    import EmailForm from 'components/forms/email-request/EmailForm'
    import HippaForm from 'components/forms/hippa/HippaForm'
    import PatientRecordsAPI from '../../../api/PatientRecordsAPI'

    export default {
        mixins: [FormMixin, HandleRequestMixin, PhysicianMixin],
        components: {
            MedicationForm,
            EmailForm,
            HippaForm,
        },
        props: {
            physician: { type: Object, required: true },
        },

        data() {
            return {
                availHipaaForms: [],
                recordTypeSources: [],
            }
        },

        methods: {
            getPatientHipaaForms() {
                PatientRecordsAPI.getHipaaFormList(this.$auth.getActiveMember()?.id, this.$route.params.id).then((res) => {
                    this.availHipaaForms = res
                })
            },
            getRecordTypeSources() {
                PatientRecordsAPI.getRecordTypeSources().then((res) => {
                    this.recordTypeSources = res.map((item) => ({
                        label: item.name,
                        value: item.id,
                    }))
                })
            },
        },

        mounted() {
            this.getRecordTypeSources()
            this.getPatientHipaaForms()
        },
    }
</script>
